import React from 'react';
import styled from 'styled-components';
import Icon from '@components/Icon';
import { Box, Container as container, Flex } from '@components/layout/Grid';
import {
  PlaylistsCollectionSubHeaderA,
  PlaylistsCollectionSubHeaderP,
} from '@components/texts';

const Container = styled(container)`
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`;

type Props = {
  links: Array<{
    displayName: React.ReactNode;
    href?: string;
  }>;
};

const BreadCrumb = (props: Props) => {
  return (
    <Container flexDirection="column" px={[15, 20, 20]}>
      <Flex className="flex-wrap" alignItems="center" py="15px">
        {props.links.map((item, index) => (
          <React.Fragment key={index}>
            <Box mx="5px">
              {item.href ? (
                <PlaylistsCollectionSubHeaderA href={item.href} $bold>
                  {item.displayName}
                </PlaylistsCollectionSubHeaderA>
              ) : (
                <PlaylistsCollectionSubHeaderP>
                  {item.displayName}
                </PlaylistsCollectionSubHeaderP>
              )}
            </Box>
            {index + 1 < props.links.length ? (
              <Box mx="5px">
                <Icon name="ygb-icon-chevron-right" />
              </Box>
            ) : null}
          </React.Fragment>
        ))}
      </Flex>
    </Container>
  );
};

export default BreadCrumb;
